<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn small color="red white--text" :loading="loading" tile @click="dialogDelete = true">Delete</v-btn>
                <v-btn small color="white accent--text" :loading="loading" tile @click="createJob" class="ml-2">Create Job</v-btn>
                <v-btn small color="white accent--text" :loading="loading" tile @click="createDeposit" class="ml-2">Create Deposit</v-btn>
            </v-toolbar>
        </v-card>
        <v-card tile>
            <v-tabs
            v-model="tab"
            background-color="primary"
            dark
            center-active
            show-arrows
            grow
            >
                <v-tab>Personal Information</v-tab>
                <v-tab>Jobs</v-tab>
                <v-tab>Deposits</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <v-card flat color="#004889">
                        <v-card-text class="pa-0">
                            <ValidationObserver ref="observer1">
                                <v-form ref="personalform">
                                    <v-list flat color="#004889" class="py-0">
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Customer ID</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                    <v-text-field
                                                    v-model="form.customer_id"
                                                    required
                                                    solo
                                                    flat
                                                    dark
                                                    ></v-text-field>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">First Name</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="First Name" rules="required">
                                                    <v-text-field
                                                    v-model="form.first_name"
                                                    :error-messages="errors"
                                                    required
                                                    solo
                                                    flat
                                                    dark
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Last Name</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="Last Name" rules="required">
                                                    <v-text-field
                                                    v-model="form.last_name"
                                                    :error-messages="errors"
                                                    required
                                                    solo
                                                    flat
                                                    dark
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Email</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="Email">
                                                    <v-text-field
                                                    v-model="form.email"
                                                    :error-messages="errors"
                                                    required
                                                    solo
                                                    flat
                                                    dark
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Phone</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="Phone" rules="required">
                                                    <v-text-field
                                                    v-model="form.phone"
                                                    :error-messages="errors"
                                                    required
                                                    solo
                                                    flat
                                                    dark
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Phone 2</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-text-field
                                                v-model="form.phone_2"
                                                required
                                                solo
                                                flat
                                                dark
                                                ></v-text-field>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Street Address</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="Street Address" rules="required">
                                                    <v-text-field
                                                    v-model="form.street_address"
                                                    :error-messages="errors"
                                                    required
                                                    solo
                                                    flat
                                                    dark
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">City</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="City" rules="required">
                                                    <v-text-field
                                                    v-model="form.city"
                                                    :error-messages="errors"
                                                    required
                                                    solo
                                                    flat
                                                    dark
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">ZIP Code</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="Zip Code" rules="required">
                                                    <v-text-field
                                                    v-model="form.zip"
                                                    :error-messages="errors"
                                                    required
                                                    solo
                                                    flat
                                                    dark
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">County</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="County" rules="required">
                                                    <v-autocomplete
                                                        :items="counties"
                                                        :filter="customFilter"
                                                        :error-messages="errors"
                                                        v-model="form.county"
                                                        color="white"
                                                        item-text="title"
                                                        item-value="id"
                                                        label="County"
                                                        required
                                                        solo
                                                        flat
                                                        dark
                                                    ></v-autocomplete>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Notes</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-textarea
                                                    v-model="form.notes"
                                                    required
                                                    solo
                                                    flat
                                                    dark
                                                ></v-textarea>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-list>
                                </v-form>
                            </ValidationObserver>
                        </v-card-text> 
                        <v-card-actions>
                            <v-btn large min-width="100%" color="white accent--text"  @click="submit" :loading="loading" tile>Update</v-btn>
                        </v-card-actions> 
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card
                        class="mx-auto"
                        flat
                        :loading="loading"
                        loader-height="10"
                        tile
                    >
                        <v-toolbar
                        color="#0c477c"
                        dark
                        flat
                        height="40"
                        >
                            <v-spacer></v-spacer>
                            <v-toolbar-title class="jobs-count" >
                                {{ total + ' Jobs Found.' }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-list tile flat class="py-0" color="primary">
                            <template v-for="(job, index) in jobs">
                                <v-list-item
                                :key="`job-${index}`"
                                :value="job.id"                 
                                >
                                    <template>
                                        <v-list-item-content @click.stop="openJob(job.id)">
                                            <v-list-item-title class="white--text">
                                                {{ 'Job# ' + job.job_no }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-action class="d-block">
                                            <v-chip
                                            :color="getColor(job.status)"
                                            text-color="white"
                                            label
                                            small
                                            >
                                                {{ job.status | capitalize }}
                                            </v-chip>
                                        </v-list-item-action>
                                    </template>
                                </v-list-item>
                                <v-divider
                                :key="`dv-${index}`"
                                ></v-divider>
                            </template>
                            <v-list-item v-if="pagination.total > 1">
                                <v-list-item-content>
                                    <v-pagination
                                        v-model="pagination.current"
                                        :length="pagination.total"
                                        @input="onPageChange"
                                        :total-visible="totalVisible"
                                    ></v-pagination>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card
                        flat
                        loader-height="10"
                        tile
                        min-width="100%"
                    >
                        <v-toolbar
                        color="#0c477c"
                        dark
                        flat
                        height="40"
                        >
                            <v-spacer></v-spacer>
                            <v-toolbar-title class="jobs-count" >
                                {{ totalDeposits + ' Deposits Found.' }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-list two-line tile flat class="py-0 hover-list primary">
                            <v-list-item-group>
                                <template v-for="(deposit, index) in deposits">
                                    <v-list-item
                                    :key="`job-${index}`"
                                    :value="deposit.id"                 
                                    >
                                        <template>
                                            <v-list-item-content @click.stop="openDeposit(deposit.id)">
                                                <v-list-item-title v-html="'Deposit# ' + deposit.id + ' - ' + deposit.customer.first_name + ' ' + deposit.customer.last_name" class="white--text"></v-list-item-title>
                                                <v-list-item-subtitle class="white--text">{{ deposit.customer.street_address+ ', ' + deposit.customer.city + ', ' + deposit.customer.state + ' ' + deposit.customer.zip }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-list-item-icon class="ma-0 mb-1 d-block">
                                                    <v-btn small tile class="mr-1" elevation="0" color="light-green" dark :to="{ name:'Deposit Edit', params:{id: deposit.id} }">
                                                        <span class="counter">{{ deposit.deposit_amount | currency }}</span>
                                                    </v-btn>
                                                </v-list-item-icon>
                                            </v-list-item-action>
                                        </template>
                                    </v-list-item>
                                    <v-divider
                                    :key="`dv-${index}`"
                                    ></v-divider>
                                </template>
                            </v-list-item-group>  
                            <v-list-item v-if="paginationDeposits.total > 1" class="accent">
                                <v-list-item-content>
                                    <v-pagination
                                        v-model="paginationDeposits.current"
                                        :length="paginationDeposits.total"
                                        @input="onPageChange"
                                        :total-visible="totalVisible"
                                        dark
                                    ></v-pagination>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
        <v-dialog
            v-model="dialogNewJob"
            persistent
            max-width="290"
        >
            <v-card color="primary">
                <v-card-title class="title text-uppercase justify-center white--text">
                Want to Create a Job?
                </v-card-title>
                <v-card-actions class="accent">
                <v-btn tile color="white darken-1" text @click="dialogNewJob = false">Cancel</v-btn>
                <v-btn tile color="accent--text" @click="createJob" :loading="loading">Create a Job</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card color="red">
            <v-card-title class="subtitle-2 justify-center white--text">Are you sure you want to delete this item?</v-card-title>
            <v-card-title class="justify-center white--text text-center">Warning! Any jobs, workorders or issues linked to this account will be removed.</v-card-title>
            <v-card-actions class="red darken-4">
              <v-spacer></v-spacer>
              <v-btn tile color="white darken-1" text @click="dialogDelete = false">Cancel</v-btn>
              <v-btn tile color="red--text" @click="deleteItemConfirm" :loading="loading">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-bottom-navigation
            color="white"
            horizontal
            app
            background-color="primary"
        >
            <v-btn 
            style="max-width: auto!important;"
            @click="sendContract"
            :loading="loadingContract"
            >
            <span>Send Contract</span>
                <v-icon>mdi-send</v-icon>
            </v-btn>
            <v-btn 
            style="max-width: auto!important;"
            @click="getContract"
            :loading="loadingContractGet"
            v-if="form.envelope_id"
            >
            <span>Download</span>
                <v-icon>mdi-cloud-download</v-icon>
            </v-btn>
        </v-bottom-navigation>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import axios from 'axios'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

export default {
    props: ['id'],
    data () {
        return {
            tab: null,
            form: {
                customer_id: '',
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                phone_2: '',
                street_address: '',
                city: '',
                state: 'AL',
                zip: '',
                service: 'Cleaning',
                county: null,
                status: '',
                notes: '',
                envelope_id: ''
            },
            loading: false,
            jobs: [],
            deposits: [],
            pagination: {
                current: 1,
                total: 0
            },
            paginationDeposits: {
                current: 1,
                total: 0
            },
            total: 0,
            totalDeposits: 0,
            totalVisible: 5,
            filter: {
                customer: "",
            },
            pageTitle: '',
            dialogNewJob: false,
            dialogDelete: false,
            loadingContract: false,
            loadingContractGet: false,
        }
    },
    created() {
        this.pageTitle = this.$route.meta.title
        this.getCustomer()
        this.getJobs()
        this.getDeposits()
    },
    mounted() {
        if(this.$route.params.newjob) {
            this.dialogNewJob = true
        }
    },
    computed: {
        ...mapGetters({
            counties: 'data/counties',
            sizes: 'data/sizes',
            options: 'data/options',
            states: 'data/states',
            statuses: 'data/statusArray',
        }),
    },
    components: {
        ValidationProvider,
        ValidationObserver
    },
    methods: {
        ...mapActions({
            updateCustomer: 'data/updateCustomer',
        }),
        customFilter (item, queryText) {
            const textOne = item.title.toLowerCase()
            const searchText = queryText.toLowerCase()

            return textOne.indexOf(searchText) > -1
        },
        getJobs() {
            this.loading = true
            this.drawer = false
            this.$set(this.filter, 'customer', this.id)
            axios.get('crm/customer/jobs/all?page=' + this.pagination.current, {
                params: this.filter
            })
            .then(response => {
                this.loading = false
                this.jobs = response.data.jobs.data
                this.pagination.current = response.data.jobs.current_page
                this.pagination.total = response.data.jobs.last_page
                this.total = response.data.jobs.total
                this.$nextTick()
            })
        },
        getDeposits() {
            this.loading = true
            this.drawer = false
            axios.get('crm/customer/deposits/all?page=' + this.paginationDeposits.current, {
                params: this.filter
            })
            .then(response => {
                this.loading = false
                this.deposits = response.data.data.data
                this.paginationDeposits.current = response.data.data.current_page
                this.paginationDeposits.total = response.data.data.last_page
                this.totalDeposits = response.data.data.total
                this.$nextTick()
            })
        },
        sendContract() {
            if(this.id) {
                window.open('https://api.mrpoolal.com/connect-docusign?id='+this.id,'_blank')
            }
        },
        getContract() {
            if(this.id) {
                window.open('https://api.mrpoolal.com/connect-docusign-download?id='+this.id,'_blank')
            }
        },
        onPageChange() {
            this.getJobs()
            this.$vuetify.goTo(0)
        },
        getCustomer() {
            if(this.id) {
                axios.get('crm/customers/get?id=' + this.id)
                    .then((response) => {
                        this.form = response.data

                        if(response.data.schedule !== null)
                            this.form.datetime = new Date(response.data.schedule)

                        this.form.status = response.data.status
                        this.$nextTick()
                    })
            }
        },
        deleteItemConfirm() {
            this.loading = true
            axios.delete('crm/customer/delete?id=' + this.id)
                .then(() => {
                    this.$router.push({ path: '/customers' })
                })
        },
        async submit() {
            let valid1 = await this.$refs.observer1.validate()

            if(valid1) {
                this.loading = true
                this.$set(this.form, 'id', this.id)
                this.updateCustomer(this.form).then(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                    if(this.$route.params.redirect == 'JobMain' || this.$route.params.redirect == 'Workorder Edit') {
                        this.$router.push({ name: this.$route.params.redirect, params: { id: this.$route.params.job, customer: this.form } })
                    } else if(this.$route.params.redirect == 'New Workorder') {
                        this.$router.push({ name: this.$route.params.redirect, params: { customer: this.form } })
                    } else {
                        this.$router.push({ path: '/customers' })
                    }
                }).catch(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                })
            } else {
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Please check your form for the errors.')

                if(!valid1) {
                    this.tab = 0
                }
            }
        },
        getColor(status) {
            switch(status) {
                case 'completed':
                    return 'green'
                case 'active':
                    return 'light-blue'
                case 'cancelled':
                    return 'red'
                default:
                    // code block
            }
        },
        openJob(id) {
            this.$router.push({ path: '/job/main/'+id })
        },
        openDeposit(id) {
            this.$router.push({ path: '/deposit/'+id })
        },
        createJob() {
            this.$router.push({ name: 'New Job', params: { customer: this.form } })
        },
        createDeposit() {
            this.$router.push({ name: 'New Deposit', params: { customer: this.form } })
        }
    }
}
</script>

<style lang="sass" scoped>
.admin-action 
    background: #1976d2
    button 
        width: 100%
        background: #ffffff
        color: #1976d2
.v-list-item__action
    .v-btn
        &:not(.v-btn--round)
            &.v-size--small
                height: 42px
.jobs-count 
    font-size: 14px
</style>